import { useTranslation } from 'react-i18next';

import { Chip } from '../ui/Chip';
import { IconBadge } from '../ui/IconBadge';
import type { Intent } from '../wizard/types';

interface IntentStepProps {
  selected: Intent | null;
  onSelect: (intent: Intent) => void;
}

const INTENT_OPTIONS: Array<{ id: Intent; icon: string }> = [
  { id: 'send', icon: '↗' },
  { id: 'request', icon: '↙' },
  { id: 'pay', icon: '⌁' },
];

export const IntentStep = ({ selected, onSelect }: IntentStepProps) => {
  const { t } = useTranslation('smart');

  return (
    <div className="grid grid-cols-3 gap-2" role="radiogroup">
      {INTENT_OPTIONS.map((opt) => (
        <Chip
          key={opt.id}
          selected={selected === opt.id}
          onClick={() => onSelect(opt.id)}
          icon={
            <IconBadge variant={selected === opt.id ? 'accent' : 'default'}>
              {opt.icon}
            </IconBadge>
          }
          label={t(`wizard.compose.intentStep.${opt.id}.label`)}
          description={t(`wizard.compose.intentStep.${opt.id}.description`)}
        />
      ))}
    </div>
  );
};
